<div #seatMapWrapper class="seat-map-wrapper" (scroll)="handleScroll()">
  <div #seatMap [innerHTML]="(flight.seatMap$ | async)?.svg | finSafe: 'html'" (click)="handleSeatClick($event)"></div>
</div>
